<div class="container-capped-sm h-min-full-header text-center  px-0">
  <img class="cover mw-100 mt-md-5" src="/assets/images/bg/404.gif" alt="not found"
    style="background-image: url(/assets/images/bg/404.svg);width: 400px;height: 400px;" />
  <div class="mt-1 mt-md-3">
    <h1>یه چیزی این وسط گم شده.</h1>
    <div class="text-right fs-normal px-3" >
      <ng-container *ngIf="showReload">
        آدرس صفحه رو دوباره چک کن
        <br />
        اگر از درستی آدرس مطمئنی صفحه رو دوباره بارگذاری کن
      </ng-container>
      <ng-container *ngIf="!showReload">
        از صفحه اول شروع کنیم؟
      </ng-container>

    </div>

    <div class="px-3">
      <button class="btn btn-yellow mt-2 mt-md-4 w-100" (click)="reload()" *ngIf="showReload">بارگذاری صفحه</button>
      <button class="btn btn-yellow mt-2 mt-md-4 w-100" routerLink="/" *ngIf="!showReload">برو به کارپیشه</button>
    </div>
  </div>
</div>